




















import { Component, Vue, Watch, Mixins } from 'vue-property-decorator'
import PageLayout from '@/components/page/PageLayout.vue'
import QuestionnaireForm from './questionnaire/QuestionnaireForm.vue'
import AddQuestion from './questionnaire/AddQuestion.vue'
import RevisitApi from '@/api/revisit'

@Component({
	name: 'editReturnVisitQuestionnaire',
	components: {
		PageLayout,
		QuestionnaireForm,
		AddQuestion,
	},
})
export default class EditQuestionnaire extends Vue {
	private templateId = ''
	private questionnaire: any = {
		questionList: [],
		companyList: [],
	}

	private addQuestion(questionList: any[]) {
		this.$set(this.questionnaire, 'questionList', questionList)
	}

	private deleteQuestion(id: number) {
		this.questionnaire.questionList = this.questionnaire.questionList.filter(
			(question: any) => question.questionId !== id
		)
		// 清空关联该问题选项的linkQuestionId
		this.questionnaire.questionList.forEach((question: any) => {
			const optionList = (question && question.optionList) || []
			optionList.forEach((option: any) => {
				if (option && option.linkQuestionId === id) {
					option.linkQuestionId = null
				}
			})
		})
	}

	private changeOrder(changedList: any[]) {
		this.questionnaire.questionList = [...changedList]
	}

	private getQuestionnaire() {
		this.templateId = this.$ls.get('questionnaireId')
		RevisitApi.getTemplateDetail(this.templateId).then((res: any) => {
			this.questionnaire = res.data
		})
	}

	private created() {
		this.getQuestionnaire()
	}
}
